import { render, staticRenderFns } from "./TeacherUpload.vue?vue&type=template&id=17557df2&"
import script from "./TeacherUpload.vue?vue&type=script&lang=ts&"
export * from "./TeacherUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports